import { Box, styled } from '@mui/joy';
import { Warning as WarningIcon } from '@phosphor-icons/react';
import { KeyboardEvent } from 'react';

import { theme } from 'theme';
import { Color } from 'theme/enums';

import Tooltip from './Tooltip';

interface IProps {
  tooltipTitle: string | JSX.Element;
  content?: JSX.Element;
  onClick?: () => void;
}

const Wrapper = styled(Box)({
  display: 'flex',
  gap: '4px',
});

const IconWrapper = styled(Box)({
  position: 'relative',
  bottom: '-2px',
});

const iconStyle = {
  color: theme.palette.danger.softColor,
};

export const Warning = ({ tooltipTitle, content, onClick }: IProps) => {
  const onKeyDown = onClick
    ? (event: KeyboardEvent<HTMLDivElement>) => {
        if ('Enter' === event.key || ' ' === event.key) {
          event.preventDefault();
          onClick();
        }
      }
    : undefined;

  return (
    <Tooltip title={tooltipTitle} color={Color.DANGER}>
      <Wrapper
        onClick={onClick}
        onKeyDown={onKeyDown}
        sx={onClick ? { cursor: 'pointer' } : undefined}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        <IconWrapper>
          <WarningIcon style={iconStyle} />
        </IconWrapper>

        {content}
      </Wrapper>
    </Tooltip>
  );
};
